(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow_with_content"] && !Shopify.designMode) return;
  try {
    
                 (function($){$.fn.slideshowgif=function(a){a=$.extend({timeout:3000,speed:400},a);return this.each(function(){var b=$(this);b.children().eq(0).appendTo(b).show();setInterval(function(){b.children().eq(0).hide().appendTo(b).fadeIn(a.speed)},a.timeout)})}}(jQuery));
    
                    $( document ).ready(function() {
                    $('.fadein1').slideshowgif({
                        'timeout': 1500,
                        'speed': 300

                    });
                });
  
                const myImg = document.querySelector('.my_image');  
                    let imgHeight = myImg.offsetHeight;
  
                  console.log(imgHeight);
                // const mydiv = document.querySelector('.mydiv'); 
             
                   function  myFunction(){
                               let imgHeight = myImg.offsetHeight;
                                  var elements = document.getElementsByClassName("mydiv");
          
                  
                      for (var i = 0; i < elements.length; i++) {
                        elements[i].style.height = `${imgHeight}px`;
                      } 
                        
                 }

                     $( window ).ready(function() {
                          myFunction();
                        
                      });
                
                      $( window ).on( "load", function() {
                          myFunction();
                     });
                      setInterval(myFunction, 1); 

     

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section-1"] && !Shopify.designMode) return;
  try {
    
new Swiper('.center-slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 16,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  // 👇 Add these lines to fix video control interaction
  allowTouchMove: true,
  touchStartPreventDefault: false,
  nested: true,

  breakpoints: {
    500: {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 24
    },
    1024: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 24
    }
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
new Swiper('.center-slider', {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 16,
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  // 👇 Add these lines to fix video control interaction
  allowTouchMove: true,
  touchStartPreventDefault: false,
  nested: true,

  breakpoints: {
    500: {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 24
    },
    1024: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 24
    }
  }
});



  } catch(e) { console.error(e); }
})();
})();
